import { HandlersLibraryTreeNode } from '../../app/athenaApiGen';

// Kebab options grouped by action type — creation first, then modification,
// then destructive — matching SharePoint / OneDrive / Drive conventions.
// ActionMenu inserts a divider before 'Delete' when other actions precede it
// so the destructive action visually separates from the rest.
// Display labels are entity-aware (see ActionMenu's ListItemText logic):
//   Delete   → "Delete File" / "Delete Folder" / "Delete Project"
//   Rename   → "Rename File" / "Rename Folder" / "Rename Project"
//   Download → "Download File" (single attachment)
//   Download All → "Download All" (folders + projects; not programs)
//   Copy Link → projects only (mirrors the Projects table kebab)
//
// NOTE: 'Move to' is intentionally absent — backend endpoint times out at
// the Azure Application Gateway (>30s) even for trivial moves. Filed as a
// BE bug. ActionMenu / MovePickerModal / librarySlice fields remain so the
// option can be restored to this array once the BE is fixed.
const menuOptions = [
  'New Folder',
  'Add File',
  'Download',
  'Download All',
  'Rename',
  'Copy Link',
  'Delete',
];

// True if the node itself or any descendant carries a truthy `blobId` — i.e.
// there is at least one real, downloadable file somewhere in the subtree.
// Folders/projects/deliverables have no `blobId`; attachments do. Used to gate
// "Download all as zip" so we never issue a request the backend must reject for
// an empty container. Recursive on purpose: a folder holding only empty
// sub-folders has children but no downloadable file, so it must return false.
const hasDownloadableFile = (node: HandlersLibraryTreeNode): boolean => {
  if (node.blobId) return true;
  return (node.children ?? []).some(hasDownloadableFile);
};

export { menuOptions, hasDownloadableFile };
